var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgShoebox(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10391_25524)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.6875 169.6C31.6875 132.022 62.1542 101.578 99.7097 101.578C137.265 101.578 167.732 132.045 167.732 169.6",
    fill: "url(#paint0_linear_10391_25524)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.4004 71.689V121.489L128.867 108.111L128.778 95.1556L84.4004 71.689Z",
    fill: "url(#paint1_linear_10391_25524)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.2656 82.9779L84.399 71.689V108.622L54.2656 82.9779Z",
    fill: "url(#paint2_linear_10391_25524)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.0217 71.8889L54.1328 83.1333L84.2439 121.6L128.733 108.222L128.666 95.2889L84.4884 71.9111C84.3328 71.8444 84.1773 71.8222 84.0217 71.8889Z",
    fill: "url(#paint3_linear_10391_25524)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.1323 136.311L54.4878 104.267C54.3545 104.156 54.2656 104 54.2656 103.822V83.0222L97.1545 110.378L97.1323 136.311Z",
    fill: "url(#paint4_linear_10391_25524)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.1543 136.244L128.599 116.378C128.754 116.267 128.865 116.089 128.865 115.911L128.799 95.1777L97.1765 110.4V136.244H97.1543Z",
    fill: "url(#paint5_linear_10391_25524)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.422 53.845C151.422 52.3117 151.155 50.8006 150.622 49.3561C149.355 45.9117 146.644 42.8006 142.666 40.3339C141.688 39.7339 140.666 39.1783 139.6 38.6895",
    stroke: "#222C46",
    strokeWidth: 0.666667,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.445 40.3337C101.023 41.8449 99.0672 43.5782 97.6228 45.4893C95.7117 48.0226 94.6895 50.8671 94.6895 53.8226C94.6895 59.0004 98.1561 63.756 104.467 67.2004",
    stroke: "#222C46",
    strokeWidth: 0.666667,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.5767 51.0674C90.3767 51.9785 90.2656 52.9118 90.2656 53.8674C90.2656 57.2896 91.7767 60.5118 94.599 63.2896",
    stroke: "#222C46",
    strokeWidth: 0.666667,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.2227 53.8447C97.2227 62.7114 110.556 69.5114 124.823 69.5114C125.845 69.5114 126.845 69.467 127.8 69.4003C128.934 69.3114 129.778 72.5114 131.223 72.4003C132.423 72.3114 133.423 68.6003 134.534 68.3114C143.334 66.0003 148.867 60.5114 148.867 53.8447C148.867 44.9781 137.312 37.7781 123.045 37.7781C108.778 37.7781 97.2227 44.9781 97.2227 53.8447Z",
    fill: "url(#paint6_linear_10391_25524)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.157 81.4892C128.433 81.4892 129.468 80.4544 129.468 79.1781C129.468 77.9017 128.433 76.8669 127.157 76.8669C125.88 76.8669 124.846 77.9017 124.846 79.1781C124.846 80.4544 125.88 81.4892 127.157 81.4892Z",
    fill: "url(#paint7_linear_10391_25524)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.689 88.0224C132.401 88.0224 132.978 87.4453 132.978 86.7335C132.978 86.0216 132.401 85.4446 131.689 85.4446C130.977 85.4446 130.4 86.0216 130.4 86.7335C130.4 87.4453 130.977 88.0224 131.689 88.0224Z",
    fill: "url(#paint8_linear_10391_25524)"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M127.268 58.3105C127.268 57.5994 127.801 57.0661 128.49 57.0661C129.201 57.0661 129.69 57.6217 129.69 58.3105C129.69 59.0439 129.201 59.555 128.49 59.555C127.779 59.555 127.268 59.0439 127.268 58.3105ZM129.623 46.9328C129.623 47.1328 129.579 47.4883 129.556 47.7328C129.401 49.3106 129.045 52.7328 128.868 55.0661H128.112C127.956 52.7328 127.556 49.2217 127.423 47.7106C127.379 47.4217 127.356 47.1328 127.356 46.955C127.379 46.3994 127.956 46.2883 128.49 46.2883C129.068 46.2883 129.623 46.4217 129.623 46.9328Z",
    fill: "#FF7510"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M122.469 58.3105C122.469 57.5994 123.002 57.0661 123.691 57.0661C124.402 57.0661 124.891 57.6217 124.891 58.3105C124.891 59.0439 124.402 59.555 123.691 59.555C123.002 59.555 122.469 59.0439 122.469 58.3105ZM124.824 46.9328C124.824 47.1328 124.78 47.4883 124.758 47.7328C124.602 49.3106 124.247 52.7328 124.069 55.0661H123.335C123.18 52.7328 122.78 49.2217 122.647 47.7106C122.602 47.4217 122.58 47.1328 122.58 46.955C122.602 46.3994 123.18 46.2883 123.713 46.2883C124.269 46.2883 124.824 46.4217 124.824 46.9328Z",
    fill: "#FF7510"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M117.668 58.3105C117.668 57.5994 118.201 57.0661 118.89 57.0661C119.601 57.0661 120.09 57.6217 120.09 58.3105C120.09 59.0439 119.601 59.555 118.89 59.555C118.201 59.555 117.668 59.0439 117.668 58.3105ZM120.046 46.9328C120.046 47.1328 120.001 47.4883 119.979 47.7328C119.824 49.3106 119.468 52.7328 119.29 55.0661H118.535C118.379 52.7328 117.979 49.2217 117.846 47.7106C117.801 47.4217 117.779 47.1328 117.779 46.955C117.801 46.3994 118.379 46.2883 118.912 46.2883C119.468 46.2883 120.046 46.4217 120.046 46.9328Z",
    fill: "#FF7510"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M125.089 99.0005L136.778 106.445L136.755 116.223L136.733 123.667L124.889 113.934",
    fill: "url(#paint9_linear_10391_25524)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.2441 114L108.444 119.845L108.4 141.267L99.3997 134.489L99.2441 114Z",
    fill: "url(#paint10_linear_10391_25524)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.512 119.933L136.601 106.422L136.645 123.667L108.512 141.445V119.933Z",
    fill: "url(#paint11_linear_10391_25524)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.422 123.334L124.733 121.245V123.889L120.422 126.622V123.334Z",
    fill: "url(#paint12_linear_10391_25524)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.2242 99.1334C98.9798 99.1334 98.8242 98.9334 98.8242 98.7334L98.9353 95.7779C98.9353 95.5556 99.1131 95.3779 99.3353 95.4001L105.469 95.5112C105.691 95.5112 105.869 95.689 105.846 95.9112C105.846 96.1334 105.669 96.289 105.446 96.289L99.7131 96.1779L99.6242 98.7334C99.6242 98.9779 99.4464 99.1334 99.2242 99.1334Z",
    fill: "url(#paint13_linear_10391_25524)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.7106 95.0661C92.4661 95.0661 92.3105 94.8661 92.3105 94.6661L92.4217 91.7105C92.4217 91.4883 92.5994 91.3328 92.8217 91.3328L98.955 91.4439C99.1772 91.4439 99.355 91.6216 99.3328 91.8439C99.3328 92.0661 99.155 92.2217 98.9328 92.2217L93.1994 92.1105L93.1105 94.6661C93.1105 94.8883 92.9328 95.0661 92.7106 95.0661Z",
    fill: "url(#paint14_linear_10391_25524)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.2223 90.8893C86.2 90.8893 86.2 90.8893 86.2223 90.8893C85.9778 90.8893 85.8223 90.6893 85.8223 90.4893L85.9334 87.5337C85.9334 87.3115 86.1334 87.1337 86.3334 87.1559L92.4667 87.267C92.6889 87.267 92.8667 87.4448 92.8445 87.667C92.8445 87.8893 92.6667 88.0448 92.4445 88.0448L86.7112 87.9337L86.6223 90.4893C86.6 90.7115 86.4223 90.8893 86.2223 90.8893Z",
    fill: "url(#paint15_linear_10391_25524)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.7125 86.6886C79.7125 86.6886 79.6903 86.6886 79.7125 86.6886C79.4681 86.6886 79.3125 86.4886 79.3125 86.2886L79.4236 83.333C79.4236 83.1108 79.6236 82.933 79.8236 82.9552L85.9569 83.0664C86.1792 83.0664 86.3569 83.2441 86.3347 83.4664C86.3347 83.6886 86.1569 83.8664 85.9347 83.8441L80.2014 83.733L80.1125 86.2886C80.0903 86.533 79.9125 86.6886 79.7125 86.6886Z",
    fill: "url(#paint16_linear_10391_25524)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_10391_25524",
    x1: 100.154,
    y1: 147.442,
    x2: 101.062,
    y2: 102.011,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1C253D",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7778,
    stopColor: "#26304B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_10391_25524",
    x1: 109.437,
    y1: 83.8637,
    x2: 101.116,
    y2: 101.717,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00446955,
    stopColor: "#1C253D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#26314C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_10391_25524",
    x1: 70.4841,
    y1: 89.93,
    x2: 69.1224,
    y2: 75.0648,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00446955,
    stopColor: "#1C253D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#26314C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_10391_25524",
    x1: 37.2381,
    y1: 94.3178,
    x2: 116.898,
    y2: 98.403,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0044699,
    stopColor: "#222C45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B3753"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_10391_25524",
    x1: 93.8025,
    y1: 110.9,
    x2: 52.0436,
    y2: 108.063,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0044699,
    stopColor: "#222C45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B3753"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_10391_25524",
    x1: 96.7761,
    y1: 128.963,
    x2: 138.081,
    y2: 89.0194,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0044697,
    stopColor: "#111A30"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#212C46"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_10391_25524",
    x1: 141.772,
    y1: 55.0993,
    x2: 90.1071,
    y2: 55.0993,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.054517,
    stopColor: "#222C45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B3753"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_10391_25524",
    x1: 129.467,
    y1: 79.1765,
    x2: 124.838,
    y2: 79.1765,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3401,
    stopColor: "#1C253D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#222C46"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_10391_25524",
    x1: 132.986,
    y1: 86.7426,
    x2: 130.398,
    y2: 86.7426,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3352,
    stopColor: "#1C253D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#222C46"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_10391_25524",
    x1: 135.288,
    y1: 110.227,
    x2: 122.662,
    y2: 113.422,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0044699,
    stopColor: "#222C45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B3753"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_10391_25524",
    x1: 99.2385,
    y1: 127.632,
    x2: 108.436,
    y2: 127.632,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0044699,
    stopColor: "#222C45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B3753"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_10391_25524",
    x1: 108.508,
    y1: 123.937,
    x2: 136.652,
    y2: 123.937,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0044699,
    stopColor: "#222C45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B3753"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_10391_25524",
    x1: 120.418,
    y1: 123.937,
    x2: 124.74,
    y2: 123.937,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0044697,
    stopColor: "#111A30"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1C263F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_10391_25524",
    x1: 98.8334,
    y1: 97.2726,
    x2: 105.866,
    y2: 97.2726,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1972,
    stopColor: "#172038"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1F2942"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_10391_25524",
    x1: 92.325,
    y1: 93.1872,
    x2: 99.3571,
    y2: 93.1872,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1972,
    stopColor: "#172038"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1F2942"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_10391_25524",
    x1: 85.8196,
    y1: 89.0178,
    x2: 92.8518,
    y2: 89.0178,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1972,
    stopColor: "#172038"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1F2942"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_10391_25524",
    x1: 79.3151,
    y1: 84.8185,
    x2: 86.3471,
    y2: 84.8185,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1972,
    stopColor: "#172038"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1F2942"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10391_25524"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 200,
    height: 200,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShoebox);
export default __webpack_public_path__ + "static/media/shoebox.eecd1267ae2fba43978b7c4c0995e023.svg";
export { ForwardRef as ReactComponent };